/**
 * Normalizes a URL to ensure consistent comparison
 * Always returns a URL with https:// prefix
 */
export default function normalizeUrl(url: string): string {
  if (!url) return url;

  // Handle protocol-relative URLs (//example.com)
  if (url.startsWith('//')) {
    return `https:${url}`;
  }

  // Convert http:// to https://
  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }

  // If already https://, return as-is
  if (url.startsWith('https://')) {
    return url;
  }

  // If no protocol, add https://
  return `https://${url}`;
}

